import React from "react";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import KuikaTooltip from "../../ui-kit/kuika-tooltip/kuika-tooltip";
import type { IBranchMergeActionsProps } from "./branch-merge-types";

export const BranchMergeActions: React.FC<IBranchMergeActionsProps> = ({
  allConflictsResolved,
  hasConflicts,
  resolvedCount,
  totalCount,
  suggestionCount,
  requiresApproval,
  completing,
  onApplySuggestions,
  onJumpToNextUnresolved,
  onCompleteMerge,
  onCancelMerge
}) => {
  const blocked = !allConflictsResolved && hasConflicts;
  const completeLabel = requiresApproval ? "Request merge" : "Complete merge";

  return (
    <div className="branch-merge__actions-footer-inner">
      <div className="branch-merge__actions-status">
        {blocked ? (
          <span className="branch-merge__actions-status-text" data-tone="warn">
            <KuikaSvg name="alert-triangle" width={15} height={15} />
            Resolve all conflicts to merge
            <strong>
              {resolvedCount}/{totalCount}
            </strong>
          </span>
        ) : (
          <span className="branch-merge__actions-status-text" data-tone="ok">
            <KuikaSvg name="circle-check" width={15} height={15} />
            All conflicts resolved
          </span>
        )}
      </div>

      <div className="branch-merge__actions-buttons">
        {blocked && suggestionCount > 0 && (
          <KuikaTooltip content="Pre-select the recommended side for confidently-suggested conflicts" position="top">
            <KuikaButton type="tertiary" size="md" onClick={onApplySuggestions}>
              <span className="branch-merge__complete-label">
                <KuikaSvg name="star" width={15} height={15} />
                Apply {suggestionCount} suggestion{suggestionCount === 1 ? "" : "s"}
              </span>
            </KuikaButton>
          </KuikaTooltip>
        )}
        {blocked && (
          <KuikaButton type="tertiary" size="md" onClick={onJumpToNextUnresolved}>
            Next unresolved
          </KuikaButton>
        )}
        <KuikaButton type="secondary" color="neutral" size="md" onClick={onCancelMerge} disabled={completing}>
          Cancel merge
        </KuikaButton>
        <KuikaTooltip
          content={
            blocked
              ? "Resolve all conflicts to continue"
              : completing
                ? `${completeLabel} in progress…`
                : requiresApproval
                  ? "Submit this merge for the branch owner's approval"
                  : "Ready to complete the merge"
          }
          position="top"
        >
          <KuikaButton
            type="primary"
            color="default"
            size="md"
            onClick={onCompleteMerge}
            disabled={blocked || completing}
            loading={completing}
            data-testid="mergeCompleteButton"
          >
            <span className="branch-merge__complete-label">
              {!completing && <KuikaSvg name="git-merge" width={16} height={16} />}
              {completeLabel}
            </span>
          </KuikaButton>
        </KuikaTooltip>
      </div>
    </div>
  );
};
